
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiWarningRectified as ObiWarningRectifiedElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-warning-rectified.js';
 
 
 

 
 export const ObiWarningRectified = createComponent({
   react: React,
   tagName: 'obi-warning-rectified',
   elementClass: ObiWarningRectifiedElement,
   events: {
     
   }
  });
 
 